import {ConfigurationApplication} from '@application/Config';

const IMAGES_URL = (): string => `${ConfigurationApplication.retrieve().cdnPath}/uaf/images`;
const VIDEOS_URL = (): string => `${ConfigurationApplication.retrieve().cdnPath}/uaf/videos`;

const FORMAT = {PNG: 'png', JPG: 'jpg', JPEG: 'jpeg'} as const;

export {FORMAT, IMAGES_URL, VIDEOS_URL};
